export const config = {
  PLAYER_AUTH_API: `${import.meta.env.VITE_API_URL}/player/auth`,
  PLAYER_REFRESH_TOKEN_API: `${import.meta.env.VITE_API_URL}/player/auth/refreshToken`,
  PROJECT_SIGNED_COOKIES_API: `${import.meta.env.VITE_API_URL}/player/project/signedCookies`,
  PROJECT_INFO_API: `${import.meta.env.VITE_API_URL}/player/project`,
  LIST_SPACE_API: `${import.meta.env.VITE_API_URL}/player/project/space`,
  SCENE_INFO_API: `${import.meta.env.VITE_API_URL}/player/scene/`,
  X_API_KEY: `${import.meta.env.VITE_X_API_KEY}`,
  COOKIE_DOMAIN: `${import.meta.env.VITE_COOKIE_DOMAIN}`,
  CLOUD_FRONT_S3_DOMAIN: `${import.meta.env.VITE_CLOUD_FRONT_S3_DOMAIN}`,
  PUBLISH_PROJECT_ID: `${import.meta.env.VITE_PUBLISH_PROJECT_ID}`,
  ZOOM: { MIN: 0.5, DEFAULT: 0.7, DEFAULT_MOBILE: 0.67, MAX: 3.5 },
  MOBILE_WIDTH: 520,
}
